export const allBrightcovePlayers = [];
export const allYouTubePlayers = [];

const isReducedMotion =
    window.matchMedia('(prefers-reduced-motion: reduce)') === true ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches === true;

function updatePauseButtons(isPlaying) {
    const buttons = document.querySelectorAll('.btn--pause');

    const iconHTML = isPlaying
        ? '<svg class="o-icon o-icon--circle-pause"><use xlink:href="#circle-pause"></use></svg>'
        : '<svg class="o-icon o-icon--play-circle"><use xlink:href="#play-circle"></use></svg>';

    const buttonText = isPlaying ? 'Pause' : 'Play';

    buttons.forEach(button => {
        const iconContainer = button.querySelector('.btn--pause div');
        const textContainer = button.querySelector('.btn--pause span');

        if (iconContainer) {
            iconContainer.innerHTML = iconHTML;
        }

        if (textContainer) {
            textContainer.textContent = buttonText;
        }
    });
}

export function toggleAllPlayers() {
    let anyPlaying = false;
    let promises = [];

    // Brightcove
    allBrightcovePlayers.forEach(player => {
        try {
            const isPaused = player.paused();

            if (isPaused) {
                const promise = player.play().then(() => {
                    anyPlaying = true;
                }).catch(error => {
                    console.error('Brightcove play error:', error);
                });
                promises.push(promise);
            } else {
                player.pause();
            }
        } catch (error) {
            console.error('Brightcove toggle error:', error);
        }
    });

    // YouTube
    if (typeof window.YT !== 'undefined' && typeof window.YT.PlayerState !== 'undefined') {
        allYouTubePlayers.forEach(player => {
            const state = player.getPlayerState();
            if (state === window.YT.PlayerState.PLAYING) {
                player.pauseVideo();
            } else {
                player.playVideo();
                anyPlaying = true;
            }
        });
    }

+    Promise.all(promises).then(() => {
        updatePauseButtons(anyPlaying);
    });
}

export function applyInitialReducedMotionState() {
    if (isReducedMotion) {
        updatePauseButtons(false); // set to "play" icon on load
    } else {
        updatePauseButtons(true);  // set to "pause" icon on load
    }
}

export function init() {
    applyInitialReducedMotionState();
}
